import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
export default function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();
  if (loading) return (
    <div style={{ minHeight:"100vh", display:"flex", alignItems:"center",
      justifyContent:"center", background:"#0A1F3D" }}>
      <div style={{ width:"48px", height:"48px", border:"4px solid #1CBCD3",
        borderTopColor:"transparent", borderRadius:"50%",
        animation:"spin 1s linear infinite" }} />
      <style>{"@keyframes spin{from{transform:rotate(0)}to{transform:rotate(360deg)}}"}</style>
    </div>
  );
  if (!isAuthenticated) return <Navigate to="/login" state={{ from:location }} replace />;
  return children;
}
